module.exports = __webpack_public_path__ + "static/media/header-image.c9fde32e.png";